module.exports = __webpack_public_path__ + "media/customizations/bellavara/logo-new-db634fd419a150491f54a47c2b534541.png";